document.addEventListener("DOMContentLoaded", function () {
	const popup = document.querySelector(".suki-header-html-3");
	const closeButton = document.querySelector(".close-popup-small-banner");

	if (popup) {
		hidePopup();

		if (closeButton) {
			closeButton.addEventListener("click", function () {
				hidePopup();
				sessionStorage.setItem("popupClosed", "true");
			});
		}

		if (sessionStorage.getItem("popupClosed") !== "true") {
			popup.style.display = "flex";
		}
	}

	function hidePopup() {
		if (popup) {
			popup.style.display = "none";
		}
	}
});
